var exports = {
  "Qs": "x2b2fbebb--fd72d7--content",
  "UU": "x2b2fbebb--fd72d7--name",
  "DD": "x2b2fbebb--fd72d7--title",
  "VA": "x2b2fbebb--fd72d7--subtitle",
  "uW": "x2b2fbebb--fd72d7--section",
};

module.exports = exports;
